import { createSection } from '../createSection'

/**
 * Options section used to wrap all option sections in a list
 *
 * @public
 */
export const boxOptions = createSection('options', 'ul')
